import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=156577e6&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"
import style0 from "./Leads.vue?vue&type=style&index=0&id=156577e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156577e6",
  null
  
)

export default component.exports